module.exports = __webpack_public_path__ + "img/lost-upArrow.a4a52b26.svg";